import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
interface SearchedJobsResponse {
  "@context": string;
  "@id": string;
  "@type": string;
  "hydra:totalItems": number;
  "hydra:member": string[];
}
export const useSearchedJobs = clubSlug => {
  const $ = _c(2);
  let t0;
  if ($[0] !== clubSlug) {
    t0 = {
      queryKey: ["club", clubSlug, "jobs"],
      queryFn: async () => {
        const response = await fetch(`/api/club-jobs?clubSlug=${clubSlug}`);
        if (!response.ok) {
          throw new Error("Erreur lors de la r\xE9cup\xE9ration des profils");
        }
        const data = await response.json();
        return data["hydra:member"];
      }
    };
    $[0] = clubSlug;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useQuery(t0);
};